<template>
<main @click.stop="peoplePop = false">
  <section class="box">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ name: 'hotel' }">酒店</el-breadcrumb-item>
      <el-breadcrumb-item :to="{name: 'hotel_list'}">酒店列表</el-breadcrumb-item>
      <el-breadcrumb-item>{{info.Name_CN}}</el-breadcrumb-item>
    </el-breadcrumb>
    <header>
      <figure>
        <h3>{{info.Name_CN}}</h3>
        <h4>{{info.DestinationName}}</h4>
        <p>TEL：{{info.Telephone}}</p>
        <p @click="scrollToDom('mapBox')">地址：{{info.Address_CN}}<i class="icon-dingweiweizhi">查看地图</i></p>
      </figure>
      <p class="grade">{{info.StarRating}}</p>
    </header>
    <dl class="imgs" v-if="imgs.length > 0">
      <dt>
        <img :src="imgs[0].ImageUrl" alt=""/>
        <p><b>{{imgs.length}}</b></p>
      </dt>
      <dd>
        <template v-for="(v, i) in imgs">
          <img :key="v.id" :src="v.ImageUrl" v-if="i > 0 && i < 7" alt=""/>
        </template>
      </dd>
    </dl>
    <nav class="nav">
      <span :class="{on: getScrollIndex === 0}" @click="scrollToDom('fx')">房型</span>
      <span :class="{on: getScrollIndex === 1}" @click="scrollToDom('xq')">详情</span>
      <span :class="{on: getScrollIndex === 2}" @click="scrollToDom('zc')">政策</span>
      <span :class="{on: getScrollIndex === 3}" @click="scrollToDom('ss')">设施</span>
      <span :class="{on: getScrollIndex === 4}" @click="scrollToDom('kf')">客房</span>
    </nav>
    <ul class="search" id="fx">
      <li>
        <p class="tit"><span>入住时间</span><span>退房时间</span></p>
        <p class="bold time" :data-count="getDateCount"><b>{{ search.CheckInDate | formatDate }}</b><b>{{ search.CheckOutDate | formatDate }}</b></p>
        <el-date-picker
          @change="changeDate"
          v-model="date"
          type="daterange"
          value-format="yyyy-MM-dd"
          :unlink-panels="true"
          range-separator="至"
          :picker-options="pickerOptions"
          start-placeholder="入住时间"
          end-placeholder="退房时间">
        </el-date-picker>
      </li>
      <li @click.stop="peoplePop = !peoplePop">
        <p class="tit"><span>房间及住客</span></p>
        <p class="bold"><b><strong>{{search.AdultCount}}</strong>成人，<strong>{{search.ChildCount}}</strong>儿童</b></p>
        <figure class="options" :class="{on: peoplePop}" @click.stop>
          <p>
            <span>成人</span>
            <el-input-number v-model="search.AdultCount" :min="1" :max="10" size="small" @change="getRoom"/>
          </p>
          <p>
            <span>儿童</span>
            <el-input-number v-model="search.ChildCount" :min="0" :max="10" size="small" @change="getRoom"/>
          </p>
        </figure>
      </li>
    </ul>
    <div class="change">
      <button :class="{on: options.hasFood}" @click="changeOptions('hasFood', !options.hasFood)">含餐</button>
      <button :class="{on: options.canCancel}" @click="changeOptions('canCancel', !options.canCancel)">可退改</button>
      <el-select v-model="options.bedType" placeholder="房型">
        <el-option v-for="v in bedTypeList" :key="v.ID" :label="v.Name_CN" :value="v.ID">{{v.Name_CN}}</el-option>
      </el-select>
    </div>
    <ul class="list" v-loading="loading">
      <template v-for="v in roomList">
      <li :key="v.RoomTypeID" v-if="v.list.length > 0">
        <figure>
          <img :src="v.image" alt="">
          <b>{{v.RoomName_CN}}</b>
          <p>
            <i class="icon-gou" v-show="v.HasWifi === 'True'">Wi-Fi</i>
            <i class="icon-gou" v-show="v.HasWindow === 'True'">有窗</i>
          </p>
        </figure>
        <ul class="options">
          <li v-for="(sub, i) in v.list" v-show="v.showMore ? true : i === 0" :key="sub.RatePlanID">
            <div class="desc">
              <p><b>{{sub.Name_CN}}</b></p>
              <p>
                <span>
                  <i class="icon-pingjia" :class="{off: !sub.canCancel}">{{ sub.canCancel ? '' : '不' }}可退改</i>
                  <i class="icon-zaocan" :class="{off: !sub.hasFood}">{{ sub.hasFood ? '' : '不' }}含早餐</i>
                </span>
              </p>
            </div>
            <div class="price">
              <b>{{sub.TotalPrice}}</b>
              <router-link tag="button" :to="{name: 'hotel_order_add', query: {...search, RatePlanID: sub.RatePlanID} }">预订</router-link>
            </div>
          </li>
          <p class="hint" v-show="v.showMore === false && v.list.length > 1" @click="showMore(v.RoomTypeID)">显示更多</p>
        </ul>
      </li>
      </template>
    </ul>
    <section class="item" id="xq">
      <h4>详情</h4>
      <div class="nodes" v-if="hotel.description" v-html="hotel.description.HotelDescription_CN"></div>
    </section>
    <section class="item" id="zc">
      <h4>政策</h4>
      <div class="nodes" v-html="getPolicysNodes"></div>
    </section>
    <section class="item" id="ss">
      <h4>设施</h4>
      <div class="tags"><span v-for="v in getHotelFacility" :key="v.Description_CN">{{v.Description_CN}}</span></div>
    </section>
    <section class="item" id="kf">
      <h4>客房</h4>
      <div class="tags"><span v-for="v in getRoomFacility" :key="v.Description_CN">{{v.Description_CN}}</span></div>
    </section>
    <section class="item" id="mapBox">
      <h4>地址</h4>
      <div id="map"></div>
    </section>
  </section>
</main>
</template>

<script>
import moment from 'moment';
let firstTime = null;
export default {
  data () {
    return {
      loading: true,
      search: {}, // 搜索条件
      date: [],
      peoplePop: false, // 住客弹窗
      // 酒店信息
      hotel: {
        hotelSummary: {}
      },
      bedTypeList: [], // 现有房型选择
      rooms: [], // 整理后房间数据
      // 酒店客房信息
      hotelBase: {},
      options: {
        hasFood: false,
        canCancel: false,
        bedType: null
      },
      tabIndex: 0,
      // 时间选择配置
      pickerOptions: {
        disabledDate (date) {
          const diff = moment().diff(date, 'd');
          if ( firstTime !== null ) {
            const diff2 = Math.abs(moment(firstTime).diff(date, 'd'));
            return diff > 0 || diff2 >= 28;
          } else {
            return diff > 0;
          }
        },
        onPick ({ minDate, maxDate }) {
          if ( minDate && !maxDate ) {
            firstTime = minDate;
          } else {
            firstTime = null;
          }
        }
      },
      top: 0
    }
  },
  created () {
    const _search = {
      CheckInDate: moment().format('YYYY-MM-DD'),
      CheckOutDate: moment().add(1, 'd').format('YYYY-MM-DD'),
      ChildCount: 0,
      AdultCount: 1
    };

    this.search = {..._search, ...this.$route.query};
    if ( !this.search.HotelID ) {
      this.$router.push({ name: 'hotel' });
      return;
    }
    this.getInfo();
    window.addEventListener('scroll', this.bodyScroll);
    this.scrollTo(0);
  },
  filters: {
    formatDate (val) {
      return moment(val).format('MM月DD日');
    },
  },
  computed: {
    getScrollIndex () {
      const { top } = this;
      const ids = ['fx', 'xq', 'zc', 'ss', 'kf'];
      const y = ids.map((v, i) => {
        const dom = document.querySelector(`#${v}`);
        return { 
          top: dom ? dom.offsetTop: 1000000, 
          index: i 
        }
      }).reverse();
      const r = y.find(v => top > v.top - 45);
      const index = r ? r.index : 0;
      return index;
    },
    getHotelFacility () {
      return this.hotel.facilities ? this.hotel.facilities.filter(v => v.Type === 'HotelFacility') : [];
    },
    getRoomFacility () {
      return this.hotel.facilities ? this.hotel.facilities.filter(v => v.Type === 'RoomFacility') : [];
    },
    getPolicysNodes () {
      const typeDesc = {
        CheckInOut: '入住和离店',
        Pets: '宠物',
        Other: '其他'
      };
      if (!this.hotel.policys) { return ''; }
      const policys = this.hotel.policys.reduce((obj, v) => {
        if (v.Type === 'General') { obj[v.Type] = v.Description_CN; return obj; }
        if ( v.Type in obj ) {
          obj[v.Type] += `<li>${v.Description_CN}</li>`
        } else {
          obj[v.Type] = `<p><b>${typeDesc[v.Type] || v.Type}</b><br /><ul>  <li>${v.Description_CN}</li>`;
        }
        return obj;
      }, {});
      const policyNodes = Object.keys(policys).reduce((txt, v) => {
        txt += v === 'General' ? policys[v] : `${policys[v]} </ul>`;
        return txt;
      }, '');
      return policyNodes;
    },
    getDateCount () {
      const { CheckInDate: first, CheckOutDate: end } = this.search;
      return ( !!first === false || !!end === false ) ? '至' : `${Math.abs(moment(first).diff(end, 'd')) + 1}晚`;
    },
    roomList () {
      const { rooms, options } = this;
      const newRooms = rooms.map(v => {
        const list = v.list.filter(sub => {
          if (options.hasFood) {
            if (!sub.hasFood) { return false; } 
          }
          if (options.canCancel) {
            if (!sub.canCancel) { return false; } 
          }
          if ( options.bedType !== null ) {
            if (sub.BedType !== options.bedType) { return false; }
          }
          return true;
        });
        return { ...v, list };
      });
      return newRooms;
    },
    info () {
      return this.hotel.hotelSummary || {};
    },
    imgs () {
      return this.hotel.hotel_imgs || [];
    }
  },
  methods: {
    drawMap () {
      const { Latitude, Longitude } = this.info;
      const map = new BMapGL.Map("map");
      // 创建地图实例 
      const point = new BMapGL.Point(Longitude, Latitude);
      const convertor = new BMapGL.Convertor();
      const pointArr = [];
      pointArr.push(point);
      convertor.translate(pointArr, 1, 5, ({ points: [{lng, lat}] }) => {
        const newPoint = new BMapGL.Point(lng, lat);
        // 创建点坐标 
        map.centerAndZoom(newPoint, 15);
        // 创建标注  
        const marker = new BMapGL.Marker(newPoint);        
        map.addOverlay(marker);

        const opts = {
            width : 160,     // 信息窗口宽度
            height: 80,     // 信息窗口高度
            title : this.info.Name_CN, // 信息窗口标题
            message: this.info.Address_CN
        }
        var infoWindow = new BMapGL.InfoWindow("地址："+this.info.Address_CN, opts);  // 创建信息窗口对象 
        marker.addEventListener("click", function(){          
          map.openInfoWindow(infoWindow, newPoint); //开启信息窗口
        }); 
        map.openInfoWindow(infoWindow, newPoint);
      })
    },
    showMore (roomTypeId) {
      const rooms = [...this.rooms].map(v => {
        v.RoomTypeID === roomTypeId && (v.showMore = true );
        return v;
      });
      this.rooms = rooms;
    },
    scrollToDom (id) {
      const top = document.querySelector(`#${id}`).offsetTop;
      this.scrollTo(top - 40);
    },
    bodyScroll () {
      const top = document.documentElement.scrollTop;
      this.top = top;
    },
    changeOptions (attr, val) {
      this.options = { ...this.options, [attr]: val };
    },
    changeDate (val) {
      const [ CheckInDate, CheckOutDate ] = val;
      this.search = { ...this.search, CheckInDate, CheckOutDate };
      this.getRoom();
    },
    async getInfo () {
      const { HotelID } = this.search;
      const hotel = await this.$axios.get('didaApi/hotelInfo?HotelID='+HotelID);
      const { didaBedTypeList, didaMealTypeList } = await this.$axios.get('/didaApi/hotelBase');
      const hotelBase = { bedType: JSON.parse(didaBedTypeList), mealType: JSON.parse(didaMealTypeList) };
      this.hotel = hotel;
      this.hotelBase = hotelBase;
      this.getRoom();
      this.drawMap();
    },
    async getRoom () {
      this.loading = true;
      const { search } = this;
      const { Success: { PriceDetails: { HotelList: [ { RatePlanList: list = [] } ] } } } = await this.$axios.get('/didaApi/hotelPriceSearch', { params: {...search, IsRealTime: 1} });
      const { roomImages, roomAttributes } = this.hotel;
      const { bedType } = this.hotelBase;
      let rooms = list;
      let other = {
        RoomName_CN: '其他',
        Name: 'Other',
        list: []
      }
      let bedTypes = [];
      rooms = rooms.reduce((arr, v) => {
        // 最低价格/晚
        v.lowestPriceInDay = v.PriceList.reduce((val, item) => {
          if ( val === null ) { return item.Price; }
          return item.Price < val ? item.Price : val;
        }, null);
        // 是否可取消
        v.canCancel = v.RatePlanCancellationPolicyList.filter(v => {
          const diff= moment().diff(moment(v.FromDate));
          return diff < 0;
        }).length > 0;
        // 记录是否含早餐
        v.hasFood = v.BreakfastType !== 1;
        // 记录床型
        bedTypes.includes(v.BedType) || bedTypes.push(v.BedType);
        const { Name_CN } = bedType.find(item => item.ID === v.BedType);
        v.Name_CN = Name_CN;

        // 没有房间类型
        if ( 'RoomTypeID' in v === false ) {
          other.list.push(v);
          return arr;
        }
        // 有房间类型
        const index = arr.findIndex(item => item.RoomTypeID === v.RoomTypeID);
        if ( index === -1 ) {
          const { RoomTypeID, RoomName_CN, MaxOccupancy, BreakfastType, BedType, StandardOccupancy } = v;
          let data = { RoomTypeID, RoomName_CN, MaxOccupancy, BreakfastType, BedType, StandardOccupancy, list: [v] };
          arr.push(data);
        } else {
          arr[index].list.push(v);
        }
        return arr;
      }, []).map(v => {
        // 客房图片
        const imgInfo = roomImages.find(item => item.RoomID === v.RoomTypeID);
        v.image = imgInfo ? imgInfo.ImageUrl : null;
        // 其他属性
        const other = roomAttributes.find(item => item.RoomTypeID === v.RoomTypeID);
        v = { ...v, ...other };
        return v;
      });
      other.list.length > 0 && rooms.push(other);
      rooms = rooms.map(v => {
        const { list } = v;
        const lowestPriceInDay = list.reduce((val, item) => {
          if ( val === null ) { return item.lowestPriceInDay; }
          return item.lowestPriceInDay < val ? item.lowestPriceInDay : val;
        }, null);
        v.list = list.sort((a, b) => a.lowestPriceInDay - b.lowestPriceInDay);
        return { ...v, lowestPriceInDay, showMore: false };
      });
      const bedTypeList = [{ ID: null, Name_CN: '床型：全部' }, ...bedType.filter(v => bedTypes.includes(v.ID))];

      this.rooms = rooms;
      this.bedTypeList = bedTypeList;
      this.loading = false;
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.bodyScroll);
  }
}
</script>

<style scoped src="./detail.css"></style>